import {CommunicationOutcome} from "../components/communication-outcome";
import { LeadAlerts } from "../components/lead-alerts";
import { Outlet } from "react-router-dom";
import { Rail } from "./Rail";
import { TopBar } from "./TopBar";
import { EmmaDrawer } from "../components/emma-drawer";
import { useCases } from "../hooks/useCases";
import {useAttention} from "../hooks/useAttention";

export function Frame() {
  const { open, error } = useCases();
  const {leads,overdueCount,count:attentionCount}=useAttention();
  return (
    <div className="flex h-screen overflow-hidden">
      <Rail badges={{ "/leads": leads.data?.length ?? 0, "/follow-ups": overdueCount }} />
      <div className="flex min-w-0 flex-1 flex-col">
        <TopBar attentionCount={attentionCount} />
        <EmmaDrawer openCases={open.length} />
        {error && <p role="alert" className="border-b bg-warning/10 px-4 py-2 text-sm">{error}</p>}
        <CommunicationOutcome />
        <LeadAlerts />
        <main className="min-w-0 flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
